import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const PlusCircleIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z" />
      <path d="M12 8V16M16 12H8" />
    </SvgIcon>
  )
}
